export default "__VITE_ASSET__CJ9rLBC5__"